import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCachetComponent } from './simple-icons-cachet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCachetComponent ],
    exports:      [ SimpleIconsCachetComponent ],
    bootstrap:    []
})
export class SimpleIconsCachetModule {}
